<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <section class="mx-auto mt-8 w-full max-w-content-container px-5 md:mt-16">
    <SectionHeader :title="title" />
    <slot />
  </section>
</template>
